/**
 * Number Field Type enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum NUMBER_FIELD_TYPE {
	DEFAULT = "input",
	SLIDER = "slider"
}
